import { render } from "./DuelsFilterSort.vue?vue&type=template&id=5fd8f6fc&scoped=true"
import script from "./DuelsFilterSort.vue?vue&type=script&lang=js"
export * from "./DuelsFilterSort.vue?vue&type=script&lang=js"

import "./DuelsFilterSort.vue?vue&type=style&index=0&id=5fd8f6fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd8f6fc"]])

export default __exports__